module.exports = __webpack_public_path__ + "static/media/mk2_pic-1_(1).f907cbdf.jpg";